import { Component, OnInit } from '@angular/core';

// Container for the sites section.
@Component({
  selector: 'hub-sites-section-container',
  templateUrl: './sites-section-container.component.html',
  styleUrls: ['./sites-section-container.component.scss']
})
export class SitesSectionContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
